<template>
  <div class="esign-footer-container">
    <footer class="pc esign-footer-wrapper">
      <!-- footer main 1400px start -->
      <div class="esign-footer">
        <!-- 链接(快捷入口) start -->
        <div class="footer-link">
          <div v-for="links in footerLink" :key="links.id" class="link-item">
            <div class="title">{{ links.title }}</div>
            <ul>
              <li v-for="item in links.children" :key="item.url">
                <a v-if="item.nofollow" class="sub-title" :href="item.url" :title="item.title" rel="nofollow">{{ item.title }}</a>
                <a v-else class="sub-title" :href="item.url" :title="item.title">{{ item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- 链接(快捷入口) end -->

        <!-- 服务热线 start -->
        <div class="about-us">
          <div class="title">服务热线</div>
          <ul class="hotline-wrapper">
            <li v-for="(item, index) in hotline" :key="index" class="item-wrapper">
              <a :href="item.url" :class="`item item-${item.id}`"
                ><i class="icon" :style="item.iconUrl ? { backgroundImage: `url(${item.iconUrl})` } : {}" />{{ item.title }}</a
              >
              <br />
              <span :class="`desc desc-${item.id}`">{{ item.desc }}</span>
            </li>

            <!-- 其他社交软件联系方式 start -->
            <li class="item-wrapper other-line" id="footup">
              <div
                v-for="(item, index) in otherLine"
                :key="index"
                class="ol-item"
                @mouseover="handleMouseover(item.id)"
                @mouseout="handelMouseout()"
              >
                <div class="ol-icon" :title="item.title"><img :src="current === item.id ? item.activeImgUrl : item.imgUrl" /></div>
                <div v-show="current === item.id" class="ol-code" @mouseover="handleMouseover(item.id)" @mouseout="handelMouseout()">
                  <img :src="item.code" />
                </div>
              </div>
            </li>
            <!-- 其他社交软件联系方式 end -->
          </ul>
        </div>
        <!-- 服务热线 end -->
      </div>
      <!-- footer main 1400px end-->
    </footer>
    <div class="footer-bottom">
      <!-- 友情链接 -->
      <div class="row friend-link">
        友情链接：
        <a v-for="link in friendLink" :key="link.url" class="link" :href="link.url" rel="nofollow">{{ link.title }}</a>
      </div>

      <!-- 备案号 -->
      <p class="row" v-html="siteConfigBanquan"></p>

      <!-- 服务协议 -->
      <div class="row agreement-link">
        <a v-for="link in agreementLink" :key="link.url" class="link" :href="link.url" rel="nofollow">{{ link.title }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default() {},
    },
    isPhone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      footerLink: this.data.footerLink || [],
      friendLink: this.data.friendLink || [],
      siteConfigBanquan: this.data.siteConfigBanquan || '',
      agreementLink: this.data.agreementLink || [],
      hotline: this.data.hotline || [],
      otherLine: this.data.otherLine || [],
      current: '',
      timer: null,
    }
  },
  methods: {
    handleMouseover(current) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.current = current
    },
    handelMouseout() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.current = ''
      }, 300)
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/style/variable.less';
@import './common.less';

.esign-footer-wrapper {
  width: 100%;
  min-height: 400px;
  padding: 58px 12px;
  background: #242424;
}
.esign-footer {
  display: flex;
  max-width: @width;
  margin: 0 auto;

  /deep/ a {
    color: #999;
    &:hover {
      color: #e61717;
    }
  }

  .desc,
  .sub-title {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
  .footer-link {
    display: flex;
    border-right: 1px solid #999999;
    flex-wrap: wrap;
    flex: 1;
  }
  .link-item {
    flex: 1;
    min-width: 150px;
    margin-bottom: 24px;
  }
  .title {
    margin-bottom: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 22px;
  }
  .sub-title {
    line-height: 32px;
  }
}
.about-us {
  padding-left: 112px;
}
.hotline-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 416px;

  .item-wrapper {
    width: 50%;
    min-width: 170px;
    margin-bottom: 16px;
  }
  .desc {
    display: inline-block;
    padding-left: 20px;
    margin-top: 4px;
    line-height: 20px;
  }
  .item {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
  }

  .other-line {
    position: relative;
    display: flex;
    justify-content: space-between;
    max-width: 162px;
    min-width: 162px;
    margin-top: 21px;
  }
}

.footer-bottom {
  text-align: center;
  color: #999999;
  line-height: 17px;
  font-size: 12px;
  background: #333;
  padding: 20px 12px 40px;
  /deep/ a {
    color: #999;
    font-size: 12px;
    &:hover {
      color: #fff;
    }
  }
  .row {
    margin-bottom: 14px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .link {
    color: #999;
    font-size: 12px;
    &::after {
      content: ' | ';
    }
    &:last-child {
      &::after {
        content: '';
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .esign-footer .link-item {
    min-width: 110px;
  }
  .about-us {
    padding-left: 70px;
  }
}
@media screen and (max-width: 900px) {
  //  .esign-footer .footer-link {
  //    display: none;
  //  }
  .about-us {
    padding-left: 70px;
  }
}
</style>
